(function () {
  "use strict";

  function createElement(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined && text !== null) el.textContent = text;
    return el;
  }

  function cleanText(value, fallback) {
    if (value === undefined || value === null || value === "") return fallback || "";
    return String(value).trim();
  }

  function getInitial(name) {
    var text = cleanText(name, "C");
    return text.charAt(0).toUpperCase();
  }

  function buildReviewCard(review) {
    var card = createElement("article", "wnv-review-card");
    var side = createElement("div", "wnv-review-side");
    var product = createElement("span", "wnv-review-product", cleanText(review.product, "World Nature Video"));
    side.appendChild(product);

    var person = createElement("div", "wnv-review-person");
    var reviewerName = cleanText(review.reviewer, "Customer");
    var avatar = createElement("div", "wnv-review-avatar", getInitial(reviewerName));
    var personText = createElement("div", "wnv-review-person-text");
    personText.appendChild(createElement("strong", "", reviewerName));

    var locationText = cleanText(review.location, "");
    if (locationText) personText.appendChild(createElement("span", "", locationText));

    var dateText = cleanText(review.date_display, "");
    if (dateText) personText.appendChild(createElement("span", "wnv-review-date", dateText));

    person.appendChild(avatar);
    person.appendChild(personText);
    side.appendChild(person);

    var main = createElement("div", "wnv-review-main");
    var titleText = cleanText(review.title, "");
    if (titleText) main.appendChild(createElement("h3", "", titleText));
    main.appendChild(createElement("p", "", cleanText(review.review, "")));

    card.appendChild(side);
    card.appendChild(main);
    return card;
  }

  function pageNumbers(currentPage, totalPages) {
    if (totalPages <= 7) {
      var allPages = [];
      for (var i = 1; i <= totalPages; i++) allPages.push(i);
      return allPages;
    }
    var pages = [1];
    if (currentPage > 4) pages.push("...");
    var start = Math.max(2, currentPage - 2);
    var end = Math.min(totalPages - 1, currentPage + 2);
    for (var page = start; page <= end; page++) pages.push(page);
    if (currentPage < totalPages - 3) pages.push("...");
    pages.push(totalPages);
    return pages;
  }

  function initializeSection(section) {
    var reviews = window.WNV_REVIEWS;
    var list = section.querySelector("[data-wnv-list]");
    var pagination = section.querySelector("[data-wnv-pagination]");
    var status = section.querySelector("[data-wnv-status]");
    var count = section.querySelector("[data-wnv-count]");
    if (!list || !pagination) return;

    if (!Array.isArray(reviews) || reviews.length === 0) {
      list.innerHTML = "";
      list.appendChild(createElement("p", "wnv-loading", "Customer reviews could not be loaded."));
      return;
    }

    var perPage = parseInt(section.getAttribute("data-per-page"), 10);
    if (!perPage || perPage < 1) perPage = 100;
    var currentPage = 1;
    var totalReviews = reviews.length;
    var totalPages = Math.ceil(totalReviews / perPage);
    if (count) count.textContent = totalReviews.toLocaleString() + " customer reviews and feedback";

    function scrollToReviews() {
      var top = section.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: "smooth" });
    }

    function makeButton(label, page, extraClass, disabled) {
      var button = createElement("button", "wnv-page-btn" + (extraClass ? " " + extraClass : ""), label);
      button.type = "button";
      if (disabled) button.disabled = true;
      button.addEventListener("click", function () {
        if (page < 1 || page > totalPages || page === currentPage) return;
        currentPage = page;
        render();
        scrollToReviews();
      });
      return button;
    }

    function renderPagination() {
      pagination.innerHTML = "";
      pagination.appendChild(makeButton("Previous", currentPage - 1, "wnv-page-wide", currentPage === 1));
      pageNumbers(currentPage, totalPages).forEach(function (page) {
        if (page === "...") {
          pagination.appendChild(createElement("span", "wnv-page-ellipsis", "..."));
          return;
        }
        var button = makeButton(String(page), page, page === currentPage ? "is-active" : "", false);
        if (page === currentPage) button.setAttribute("aria-current", "page");
        pagination.appendChild(button);
      });
      pagination.appendChild(makeButton("Next", currentPage + 1, "wnv-page-wide", currentPage === totalPages));
    }

    function render() {
      list.innerHTML = "";
      var startIndex = (currentPage - 1) * perPage;
      var endIndex = Math.min(startIndex + perPage, totalReviews);
      var fragment = document.createDocumentFragment();
      for (var i = startIndex; i < endIndex; i++) fragment.appendChild(buildReviewCard(reviews[i]));
      list.appendChild(fragment);
      if (status) status.textContent = "Showing " + (startIndex + 1).toLocaleString() + "–" + endIndex.toLocaleString() + " of " + totalReviews.toLocaleString() + " reviews";
      renderPagination();
    }
    render();
  }

  function initializeAll() {
    document.querySelectorAll("[data-wnv-reviews]").forEach(function (section) { initializeSection(section); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeAll);
  else initializeAll();

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-wnv-reviews]");
    if (section) initializeSection(section);
  });
})();

